import React, { useEffect, useState } from "react";
import { LOGIN_PAGE_CONSTANTS } from "@src/constants/UiConstants";
import RegisterAccount from "@src/pages/login/register/RegisterAccount";
import styles from "@src/components/login-modal/LoginModal.module.scss";
import { useNavigate } from "react-router-dom";
import RegistrationSuccessful from "@src/pages/login/registration-successful/RegistrationSuccessful";
import ForgotPassword from "@src/pages/login/forgot-password/ForgotPassword";
import PasswordChangeSuccess from "@src/pages/login/password-change-success/PasswordChangeSuccess";
import ExpiredActivationLink from "@src/pages/login/expired-activation-link/ExpiredActivationLink";
import SetPasswordLinkExpired from "@src/pages/login/set-password-link-expired/SetPasswordLinkExpired";
import ResetPasswordLinkExpired from "@src/pages/login/reset-password-link-expired/ResetPasswordLinkExpired";
import ResetLinkSuccess from "@src/pages/login/reset-link-success/ResetLinkSuccess";
import SetPassword from "@src/pages/login/set-password/SetPassword";
import ResetPassword from "@src/pages/login/set-password/ResetPassword";
import { useDispatch, useSelector } from "react-redux";
import { setUserLogin } from "@src/app/globalSlice";
import { RootState } from "@src/app/store";
import { Typography } from "top-brains-ui";
import Modal from "../modal/Modal";
import ChangePasswordModal from "@src/pages/login/change-password/ChangePasswordModal";

interface LoginModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  modelType?: string;
}

const RegisterModal: React.FC<LoginModalProps> = ({ isOpen, modelType }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCloseModal = () => {
    navigate("/");
  };
  const isLogin = useSelector((state: RootState) => state.globalSlice.isLogin);

  // const handleSignUpClick = () => {
  //   dispatch(setUserLogin(false));
  //   navigate("/signup");
  // };

  const [modalSize, setModalSize] = useState({
    width: "480px",
    height: "640px",
    maxHeight: "620px",
  });

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 480) {
        setModalSize({ width: "85%", height: "auto", maxHeight: "auto" });
      } else if (window.innerWidth <= 768) {
        setModalSize({ width: "90%", height: "480px", maxHeight: "480px" });
      } else {
        setModalSize({ width: "480px", height: "640px", maxHeight: "620px" });
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (modelType && modelType !== "login" && isLogin) {
      dispatch(setUserLogin(false));
    }
  }, [isLogin, modelType, dispatch]);

  return (
    <Modal
      isOpen={isOpen ?? true}
      onClose={handleCloseModal}
      showPrimaryButton={false}
      showSecondaryButton={false}
      closeOnOutsideClick={false}
      showCloseButton={true}
      height={modalSize.height}
      maxHeight={modalSize.maxHeight}
      width={modalSize.width}
      variant="website"
      showFooter={false}
      body={
        <>
          {modelType === "signup" ? (
            <RegisterAccount />
          ) : modelType === "registration-success" ? (
            <RegistrationSuccessful />
          ) : modelType === "forgot-password" ? (
            <ForgotPassword />
          ) : modelType === "password-success" ? (
            <PasswordChangeSuccess />
          ) : modelType === "link-expired" ? (
            <ExpiredActivationLink />
          ) : modelType === "set-password-link-expired" ? (
            <SetPasswordLinkExpired />
          ) : modelType === "reset-password-link-expired" ? (
            <ResetPasswordLinkExpired />
          ) : modelType === "resent-password-link" ? (
            <ResetLinkSuccess />
          ) : modelType === "set-password" ? (
            <SetPassword />
          ) : modelType === "reset-password" ? (
            <ResetPassword />
          ) : modelType === "change-password" ? (
            <ChangePasswordModal />
          ) : null}

          {/* {modelType !== "signup" && (
            <div className={styles.defaultSection}>
              <div className={styles.createAccount}>
                <Typography
                  fontWeight="medium"
                  textAlign="center"
                  fontSize={16}
                  color="#ffffff"
                >
                  {[
                    "registration-success",
                    "password-success",
                    "link-expired",
                  ].includes(modelType as string) ? (
                    <>
                      {LOGIN_PAGE_CONSTANTS.ACCOUNT_EXSISTING}
                      <span
                        className={styles.createAccountLink}
                        onClick={() => {
                          navigate("/");
                          dispatch(setUserLogin(true));
                        }}
                      >
                        {" "}
                        Login
                      </span>
                    </>
                  ) : (
                    <>
                      {LOGIN_PAGE_CONSTANTS.CREATE_ACCOUNT}
                      <span
                        className={styles.createAccountLink}
                        onClick={handleSignUpClick}
                      >
                        {" "}
                        Sign Up
                      </span>
                    </>
                  )}
                </Typography>
              </div>
            </div>
          )} */}

          {[
            "signup",
            "set-password",
            "forgot-password",
            "reset-password",
          ].includes(modelType ?? "") ? (
            <div className={styles.registerAccount}>
              <Typography
                fontWeight="medium"
                textAlign="center"
                fontSize={16}
                color="var(--website-text-color4)"
              >
                {LOGIN_PAGE_CONSTANTS.ACCOUNT_EXSISTING}
                <span
                  style={{
                    color: "var(--radio-btn-active-border-color)",
                    cursor: "pointer",
                    fontWeight: "700",
                    fontSize: "18px",
                  }}
                  onClick={() => {
                    navigate("/");
                    dispatch(setUserLogin(true));
                  }}
                >
                  {" "}
                  Sign In
                </span>
              </Typography>
            </div>
          ) : null}

          <div className={styles.supportStyles}>
            {/* <Typography fontSize={16} color="#A8A8A8">
              Terms & Conditions
            </Typography>
            <Typography fontSize={16} color="#A8A8A8">
              Support
            </Typography>
            <Typography fontSize={16} color="#A8A8A8">
              Customer Care
            </Typography> */}
          </div>
        </>
      }
    />
  );
};

export default RegisterModal;
